'use client';

import { Button } from '@mui/material';
import { useContext } from 'react';

import { colors } from '@/colors';
import { AccordionContainer } from '@/components/AccordionContainer';
import { Container } from '@/components/Container';
import { Order } from '@/components/Order';
import { DataContext } from '@/contexts/DataContext';
import { OrderContext } from '@/contexts/OrderContext';
import { useAppPush } from '@/hooks/useAppPush';
import useTranslation from '@/hooks/useTranslation';

export const SectionNewOrders = () => {
  const t = useTranslation();
  const { push } = useAppPush();
  const { orderCountPerStatus } = useContext(DataContext);
  const { newOrdersTruncated } = useContext(OrderContext);

  const totalNrOfNewOrders = orderCountPerStatus?.NEW ?? 0;
  const nrOfShownNewOrders = newOrdersTruncated.length;
  const nrOfHiddenNewOrders = totalNrOfNewOrders - nrOfShownNewOrders;

  return (
    <AccordionContainer keyName={'NEW_ORDERS'} visibleTitle={`${t('section.NEW_ORDERS')}: ${totalNrOfNewOrders}`}>
      <Container sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {newOrdersTruncated.map((newOrder) => (
          <Order key={`new-order-${newOrder.id}`} order={newOrder} />
        ))}
        {totalNrOfNewOrders > 3 && (
          <Container debugColor={'forestgreen'} sx={{ color: colors.grayDarkest }}>
            {t('order.new.xHiddenOrders', nrOfHiddenNewOrders, undefined, { x: nrOfHiddenNewOrders })}
          </Container>
        )}
        {totalNrOfNewOrders === 0 && (
          <Container debugColor={'darkslateblue'} sx={{ marginTop: '12px' }}>
            ({t('order.new.empty')})
          </Container>
        )}
        <Container debugColor={'darkslateblue'} sx={{ marginBottom: '12px' }}>
          <Button
            onClick={() => {
              push('/orders?status=NEW');
            }}
          >
            {nrOfHiddenNewOrders > 0 ? t('general.showAll') : t('order.goToFocusedView')}
          </Button>
        </Container>
      </Container>
    </AccordionContainer>
  );
};
